

var md5 = require('@/utils/md5.js');
// 根据字母排序
function objKeySort(obj) {//排序的函数
    var newkey = Object.keys(obj).sort();
　　//先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    var newObj = {};//创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj;//返回排好序的新对象
}
// 对象转拼接参数
function toQueryPair(key, value) {
  if (typeof value == 'undefined') {
    return `&${key}=`;
  }
  return `&${key}=${value}`;
}
function objToParam(param) {
  if (Object.prototype.toString.call(param) !== '[object Object]') {
    return '';
  }
  let queryParam = '';
  for (let key in param) {
    if (param.hasOwnProperty(key)) {
      let value = param[key];
      queryParam += toQueryPair(key, value);
    }
  }
  return queryParam;
}
function setNewVal(obj){
  // let val = encodeURIComponent(value);
  // let val = value;
  // console.log('编码后：', val);
  // if(val != ""){
  //   const pattern= /[^\u4e00-\u9fa5a-zA-Z0-9]/g;
  //   return val.replace(pattern,"");
  //   console.log('提取文字英文数字后：', val);
  // }
  const pattern = /[^\u4e00-\u9fa5a-zA-Z0-9]/g;
  for (var key in obj) {
    if (obj[key] != '') {
      obj[key] = encodeURIComponent(obj[key]).replace(pattern, '');
    }
  }
  return obj;
}
function getApiSign(data) {
    if (JSON.stringify(data) === '{}' || !data) return md5.hexMD5('yaojike');
    let datas = objKeySort(data);
    for (var key in datas) {
      if (datas[key] === null || datas[key] === '' || datas[key] === undefined) {
        delete datas[key];
      } else if (typeof datas[key] === 'object') {
        // datas[key] = JSON.stringify(datas[key]);
        delete datas[key];
      } else {
        datas[key] = String(datas[key]).replace(/\s/g, '');
      }
      // console.log(key)
    }
    if (JSON.stringify(datas) === '{}')  return md5.hexMD5('yaojike');
    datas = setNewVal(datas);
    console.log('剔除后', datas);
    console.log('提交参数', objToParam(datas).substring(1) + 'yaojike');
    datas = md5.hexMD5(objToParam(datas).substring(1) + 'yaojike')
    console.log('加密串', datas);
    // let a = 'decryptData=9xzsSt3lwwPP9cdbkZfuI84J2qG7Hg0uTzNGeaGBkvxubSShCFaw2gX0W7Muj56gnKdALbdzdh/9EQ/kwyJsxHZcZyKkeQIhFXBbqzt1hiy6GvMI65KWYc364VFu6jOX0StjqxoOSB/4LCTwXC7tytTF1dtGgEHUjRjO38Z7VbsR4qBKT4z/bn3VdYHt8QZ4pjF0YILudF3QdWNTAA==&ivParameter=rtETHy/nsGEI/R4wDZFW7g==&openid=o5ACi4vnMmJ4pTQSlYNRU4Cq_2hM';
    // console.log(md5.hexMD5(a));
    return datas;
}


export default {
  getApiSign
}
